import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Line = styled(Box)`
  width: 4px;
  flex: 1;
  background-color: ${(props) => props.theme.colors.grey_5};
  margin: ${(props) => props.theme.spacing['1']} 0;
`

export const Circle = styled(Box)<{ active?: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.active ? props.theme.colors.custom.white : props.theme.colors.grey_4};
  border: 8px solid
    ${(props) =>
      props.active
        ? props.theme.colors.state.warning
        : props.theme.colors.grey_5};
  box-shadow: ${(props) =>
    props.active
      ? `0px 0px 0px 4px ${props.theme.colors.state.warning + 66}`
      : `0px 0px 0px 2px ${props.theme.colors.grey_4}`};
`
export const Bedge = styled.small`
  display: flex;
  justify-content: center;
  text-align: center;
  color: ${(props) => props.theme.colors.custom.purple};
  background-color: ${(props) => props.theme.colors.custom.purple + 22};
  border: 1px solid ${(props) => props.theme.colors.grey_4};
  padding: 0 0.5rem;
  border-radius: 50px;
`
